<!-- High-Density Responsive Filters & Actions Control Toolbar Pane -->
<div class="d-flex flex-wrap align-items-end gap-3 bg-body-tertiary p-3 rounded-4 border shadow-sm">

  <!-- Section A: Primary Action Modifiers Triggers -->
  @if (isUploadNewDownloadAccess) {
  <div class="d-flex gap-2">
    <!-- Upload Batch Ingestion Button -->
    <button type="button"
      class="btn btn-sm btn-primary px-3 py-2 shadow-sm d-inline-flex align-items-center gap-1.5 fw-semibold transition-base"
      data-bs-toggle="modal" data-bs-target="#uploadCSVModal">
      <i class="fa-solid fa-cloud-arrow-up"></i>
      <span class="d-none d-sm-inline">Upload</span>
    </button>

    <!-- Create Single Record Ingestion Button -->
    <button type="button"
      class="btn btn-sm btn-outline-primary px-3 py-2 shadow-sm d-inline-flex align-items-center gap-1.5 fw-semibold text-body transition-base"
      data-bs-toggle="modal" data-bs-target="#newQrCode">
      <i class="fa-solid fa-plus font-xs text-body"></i>
      <span class="text-body">New QR Code</span>
    </button>

    <!-- Download Ingestion Extraction Template Button -->
    <button type="button"
      class="btn btn-sm btn-warning px-3 py-2 shadow-sm d-inline-flex align-items-center gap-1.5 fw-semibold transition-base"
      data-bs-toggle="modal" data-bs-target="#downloadCSVModal">
      <i class="fa-regular fa-circle-down fs-6"></i>
      <span class="d-none d-sm-inline">Download</span>
    </button>
  </div>
  }

  <!-- Section B: Live Inventory Serial Filter Engine -->
  <div class="filter-input-field flex-grow-1 max-w-300">
    <label class="form-label font-xs fw-bold text-uppercase tracking-wider text-body-secondary mb-1.5">Search By
      Serial</label>
    <div class="input-group shadow-sm rounded">
      <span class="input-group-text border bg-body text-body-secondary font-xs"><i
          class="fa-solid fa-qrcode"></i></span>
      <input type="text" class="form-control form-control-sm text-body font-xs border-start-0 ps-0"
        placeholder="Enter tracking serial..." name="checkSerial" [(ngModel)]="searchSerial" />
      <button class="btn btn-sm btn-primary px-2.5" type="button" (click)="searchQRListByNumber()"
        [disabled]="!searchSerial">
        <i class="fa-solid fa-magnifying-glass font-xs"></i>
      </button>
      <button class="btn btn-sm btn-danger px-2.5" type="button" (click)="clearSearchQRListByNumber()"
        [disabled]="!searchSerial">
        <i class="fa-solid fa-xmark font-xs"></i>
      </button>
    </div>
  </div>

  <!-- Section C: Advanced Governance Audit Search Tracking Modules -->
  @if (isClaimRecordAccess) {
  <div class="filter-input-field flex-grow-1 max-w-300">
    <label class="form-label font-xs fw-bold text-uppercase tracking-wider text-body-secondary mb-1.5">QR Illegal Claim
      Record</label>
    <div class="input-group shadow-sm rounded">
      <span class="input-group-text border bg-body text-body-secondary font-xs"><i
          class="fa-solid fa-triangle-exclamation"></i></span>
      <input type="search" class="form-control form-control-sm text-body font-xs border-start-0 ps-0"
        placeholder="Enter tracking serial..." name="checkSerial" [(ngModel)]="checkSerial" />
      <button type="button" class="btn btn-sm btn-primary px-3 fw-medium font-xs" (click)="checkQrClaimHistory()"
        [disabled]="!checkSerial">Search</button>
    </div>
  </div>

  <div class="filter-input-field flex-grow-1 max-w-300">
    <label class="form-label font-xs fw-bold text-uppercase tracking-wider text-body-secondary mb-1.5">User Claim
      Record</label>
    <div class="input-group shadow-sm rounded">
      <span class="input-group-text border bg-body text-body-secondary font-xs"><i class="fa-solid fa-phone"></i></span>
      <input type="text" class="form-control form-control-sm text-body font-xs border-start-0 ps-0"
        placeholder="Enter target phone number..." name="checkPhone" [(ngModel)]="checkPhone" />
      <button type="button" class="btn btn-sm btn-primary px-3 fw-medium font-xs" (click)="checkClaimPhoneHistory()"
        [disabled]="!checkPhone">Search</button>
    </div>
  </div>
  }

</div>

<!-- High-Density Responsive Table Dynamic Scaling Window Frame Layer -->
<div class="card border shadow-sm rounded-4 overflow-hidden bg-body mt-3 w-100 me-3">
  <div class="table-responsive-container m-0">
    <table class="table table-hover align-middle mb-0 table-dense text-nowrap">

      <!-- Table Heading Structural Constraints Mapping Definitions -->
      <thead class="table-light text-body-secondary font-monospace small text-uppercase tracking-wider border-bottom">
        <tr>
          <th scope="col" class="ps-3" width="60">No</th>
          <th scope="col" style="min-width: 110px;">Serial</th>
          <th scope="col" style="min-width: 160px;">Qr Code</th>
          <th scope="col" class="text-end" width="90">Points</th>
          <th scope="col" class="text-center" width="100">Enabled</th>
          <th scope="col" style="min-width: 160px;">Lucky Draw Name</th>
          <th scope="col" style="min-width: 155px;">Claim Time</th>
          <th scope="col" class="text-center" width="120">Illegal Check</th>
          <th scope="col" style="min-width: 140px;">Customer Phone</th>
          @if (isQREnableDisableAccess) {
          <th scope="col" class="pe-4 text-end" width="120">Disable QR</th>
          }
        </tr>
      </thead>

      <!-- Table Body Data Rows Streams Processing Iteration Core Loop -->
      <tbody class="small text-body">
        @for (qr of qrcodes() | paginate : { itemsPerPage: pageSize(), currentPage: page() + 1, totalItems: allTotal()
        }; track qr.serialNumber; let i = $index) {
        <tr class="transition-base cursor-pointer" (dblclick)="qrCodeDetail(qr.serialNumber)">
          <!-- Serial Position counter layout -->
          <td class="ps-3 text-body-secondary font-monospace fw-medium">{{ qr.srNo }}</td>
          <td class="font-monospace fw-semibold text-body">{{ qr.serialNumber }}</td>
          <td class="font-monospace text-body-secondary">{{ qr.qrCode }}</td>
          <td class="font-monospace text-end fw-bold text-primary-emphasis pe-3">{{ qr.points | number }}</td>

          <!-- Sync Verification Status Indicator -->
          <td class="text-center">
            <i class="bi fs-5"
              [ngClass]="qr.enabled ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'"></i>
          </td>

          <td class="fw-medium">{{ qr.luckyDrawName || '-' }}</td>
          <td class="text-body-secondary font-xs font-monospace">{{ qr.claimTimeStamp | dateFormat }}</td>

          <!-- Illegal Status Flag Tag -->
          <td class="text-center">
            <span class="badge px-2.5 py-1.5 rounded-pill font-xs fw-semibold tracking-wide"
              [ngClass]="qr.hasIllegalClaims ? 'bg-danger-subtle text-danger-emphasis border border-danger-subtle' : 'bg-success-subtle text-success-emphasis border border-success-subtle'">
              {{ qr.hasIllegalClaims ? 'ILLEGAL' : 'CLEAR' }}
            </span>
          </td>

          <td>
            @if (qr.claimCustomerLoginPhone) {
            <a class="font-monospace fw-medium text-primary"
              [routerLink]="['/nav/customer-info', qr.claimCustomerLoginPhone]">{{ qr.claimCustomerLoginPhone }}</a>
            } @else {
            <span class="text-body-secondary opacity-50 fst-italic font-xs">Unclaimed</span>
            }
          </td>

          <!-- System Access Control: Enable/Disable QR Code Button -->
          @if (isQREnableDisableAccess) {
          <td class="pe-4 text-end">
            @if (qr.claimCustomerLoginPhone === null && qr.enabled) {
            <button type="button"
              class="btn btn-sm btn-icon btn-outline-danger rounded-circle shadow-sm transition-base d-inline-flex align-items-center justify-content-center border"
              style="width: 28px; height: 28px;" (click)="enableQrcode(qr.serialNumber, 'disabled', i)"
              [disabled]="isEnableBtnLoading()[i]" title="Disable QR Code">
              @if (isEnableBtnLoading()[i]) {
              <span class="spinner-border micro-spinner m-0" role="status" aria-hidden="true"></span>
              } @else {
              <i class="bi bi-slash-circle font-xs"></i>
              }
            </button>
            } @else {
            <span class="text-body-secondary opacity-25 font-xs pe-2">—</span>
            }
          </td>
          }
        </tr>
        } @empty {
        <!-- Fallback Directory Placeholder -->
        <tr>
          <td colspan="10" class="text-center py-5 text-body-secondary">
            <i class="bi bi-inbox fs-2 d-block mb-2 opacity-50 text-body-secondary"></i>
            No Qr Code record found.
          </td>
        </tr>
        }
      </tbody>

    </table>
  </div>
</div>

<!-- Navigation Pagination Footer -->
<div
  class="card-footer bg-transparent border-top py-3 px-4 transition-base d-flex flex-column flex-sm-row align-items-center justify-content-center">
  <pagination-controls [maxSize]="10" previousLabel="&laquo;" nextLabel="&raquo;" [responsive]="true"
    class="dashboard-pagination" (pageChange)="handlePageChange($event)">
  </pagination-controls>
</div>

<!-- Floating Mini Card Indicator -->
@if (loading()) {
<div
  class="position-fixed bottom-0 end-0 m-2 z-3 p-3 bg-body card border-info border-opacity-25 shadow-sm d-flex flex-row align-items-center gap-2"
  style="backdrop-filter: blur(4px);">
  <!-- Mini Spinner -->
  <div class="spinner-border text-info" style="width: 1rem; height: 1rem; border-width: 2px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <!-- Text Badge Layout (Uses your global micro utilities) -->
  <div class="font-monospace text-info fw-bold tracking-widest text-uppercase pe-1 font-xs">
    Loading...
  </div>
</div>
}


<!-- ========================================== -->
<!-- CREATE INDIVIDUAL QR CODE MODAL CONTAINER  -->
<!-- ========================================== -->
<div class="modal fade" id="newQrCode" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content shadow-lg border-0 bg-body">

      <!-- Modal Header -->
      <div class="modal-header border-bottom px-4 py-3">
        <h5 class="modal-title fw-bold text-gradient-primary">
          <i class="fa-solid fa-qrcode me-2"></i>Add New QR Code
        </h5>
        <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body px-4 py-4">
        <form [formGroup]="qrCodeDataFrom" (ngSubmit)="submitNewQrcode()" class="d-flex flex-column gap-3">

          <!-- Serial Number Input -->
          <div class="row align-items-center g-2">
            <div class="col-4 col-md-3">
              <label class="form-label small fw-bold text-body-secondary mb-0">Serial Number</label>
            </div>
            <div class="col-8 col-md-9">
              <input type="text" class="form-control shadow-sm font-monospace" placeholder="Enter tracking serial"
                formControlName="serialNumber" />
            </div>
          </div>

          <!-- QR Code Content Input -->
          <div class="row align-items-center g-2">
            <div class="col-4 col-md-3">
              <label class="form-label small fw-bold text-body-secondary mb-0">QR Code Content</label>
            </div>
            <div class="col-8 col-md-9">
              <input type="text" class="form-control shadow-sm font-monospace" placeholder="Scan or type payload"
                formControlName="qrCode" />
            </div>
          </div>

          <!-- Points Value Input -->
          <div class="row align-items-center g-2">
            <div class="col-4 col-md-3">
              <label class="form-label small fw-bold text-body-secondary mb-0">Points</label>
            </div>
            <div class="col-8 col-md-9">
              <input type="text" class="form-control shadow-sm font-monospace" placeholder="Assign credit volume"
                formControlName="points" />
            </div>
          </div>

          <!-- Form Submission Row -->
          <div class="row g-2 mt-2">
            <div class="col-4 col-md-3"></div>
            <div class="col-8 col-md-9">
              <button type="submit"
                class="btn btn-sm btn-primary px-4 py-2 shadow-sm w-100 d-inline-flex align-items-center justify-content-center gap-2 fw-semibold micro-action-btn"
                [disabled]="!qrCodeDataFrom.valid || apiLoading()">
                @if (apiLoading()) {
                <span class="spinner-border micro-spinner" role="status" aria-hidden="true"></span>
                <span>Processing...</span>
                } @else {
                <span>Submit QR Token <i class="fa-solid fa-paper-plane font-xs"></i></span>
                }
              </button>
            </div>
          </div>

        </form>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer border-top px-4 py-2.5">
        <button type="button" class="btn btn-sm btn-warning shadow-sm px-3 py-1.5 fw-medium"
          data-bs-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>

<!-- ========================================== -->
<!-- BATCH CSV FILE UPLOAD MODAL CONTAINER      -->
<!-- ========================================== -->
<div class="modal fade" id="uploadCSVModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content shadow-lg border-0 bg-body">

      <!-- Modal Header -->
      <div class="modal-header border-bottom px-4 py-3">
        <h5 class="modal-title fw-bold text-gradient-primary">
          <i class="fa-solid fa-file-csv me-2"></i>QR Code Upload CSV File
        </h5>
        <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body px-4 py-4 d-flex flex-column gap-3">
        <div>
          <label class="form-label small fw-bold text-body-secondary mb-2">Select Target Spreadsheet Source</label>
          <div class="input-group shadow-sm rounded">
            <input type="file" class="file-input form-control" enctype="multipart/form-data" accept=".csv"
              (change)="onFileSelected($event)" [disabled]="apiLoading()" />
          </div>
        </div>

        <!-- Dynamic Server API Validation Error Banner -->
        @if (isApiError) {
        <div
          class="alert alert-danger d-flex align-items-center gap-2 m-0 py-2.5 border-0 shadow-sm font-monospace small"
          role="alert">
          <i class="fa-solid fa-circle-exclamation fs-5 text-danger"></i>
          <div>{{ errorMessage }}</div>
        </div>
        }
      </div>

      <!-- Modal Footer Controls -->
      <div class="modal-footer border-top px-4 py-2.5">
        <button type="button" class="btn btn-sm btn-secondary opacity-75 shadow-sm px-3 py-1.5 fw-medium"
          data-bs-dismiss="modal" [disabled]="apiLoading()">Close</button>
        <button type="button"
          class="btn btn-sm btn-primary px-4 py-1.5 shadow-sm fw-bold d-inline-flex align-items-center gap-2 micro-action-btn"
          (click)="uploadFile()" [disabled]="apiLoading()">
          @if (apiLoading()) {
          <span class="spinner-border micro-spinner" role="status" aria-hidden="true"></span>
          <span>Ingesting...</span>
          } @else {
          <span>Ingest Document <i class="fa-solid fa-cloud-arrow-up font-xs"></i></span>
          }
        </button>
      </div>

    </div>
  </div>
</div>

<!-- ========================================== -->
<!-- RECONCILIATION FILE DOWNLOAD MODAL LAYER   -->
<!-- ========================================== -->
<div class="modal fade" id="downloadCSVModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content shadow-lg border-0 bg-body">

      <!-- Modal Header -->
      <div class="modal-header border-bottom px-4 py-3">
        <h5 class="modal-title fw-bold text-gradient-primary">
          <i class="fa-solid fa-file-csv me-2"></i>QR Code Download CSV File
        </h5>
        <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body px-4 py-4">
        <div class="mb-0">
          <label class="form-label small fw-bold text-body-secondary mb-2">Export Target Document Filename
            Configuration</label>
          <div class="input-group shadow-sm rounded">
            <span class="input-group-text border">
              <i class="fa-solid fa-file-signature text-muted"></i>
            </span>
            <input type="text" class="form-control" placeholder="Enter file name" [(ngModel)]="downloadFileName"
              [disabled]="apiDownloading()" />
            <span class="input-group-text border font-monospace small">.csv</span>
          </div>
        </div>
      </div>

      <!-- Modal Footer Controls Grid -->
      <div class="modal-footer border-top px-4 py-2.5">
        <button type="button" class="btn btn-sm btn-secondary opacity-75 shadow-sm px-3 py-1.5 fw-medium"
          data-bs-dismiss="modal" [disabled]="apiDownloading()">Close</button>
        <button type="button"
          class="btn btn-sm btn-primary px-4 py-1.5 shadow-sm fw-bold d-inline-flex align-items-center gap-2 micro-action-btn"
          (click)="downloadFile()" [disabled]="!downloadFileName || apiDownloading()">
          @if (apiDownloading()) {
          <span class="spinner-border micro-spinner" role="status" aria-hidden="true"></span>
          <span>Extracting...</span>
          } @else {
          <span>Extract Matrix <i class="fa-solid fa-circle-down font-xs"></i></span>
          }
        </button>
      </div>

    </div>
  </div>
</div>